document.addEventListener('DOMContentLoaded',()=>{
 const b=document.querySelector('[data-kg-menu]'),m=document.querySelector('[data-kg-mobile-menu]');
 if(b&&m)b.addEventListener('click',()=>{m.classList.toggle('is-open');b.setAttribute('aria-expanded',m.classList.contains('is-open'))});
 const sliders=document.querySelectorAll('[data-kg-slider]');
 sliders.forEach(sl=>{const slides=[...sl.querySelectorAll('.kg-slide')]; if(slides.length<2)return;let i=0;const show=n=>{slides.forEach((s,j)=>s.classList.toggle('is-active',j===n));};
 sl.querySelectorAll('[data-next]').forEach(x=>x.onclick=()=>{i=(i+1)%slides.length;show(i)});sl.querySelectorAll('[data-prev]').forEach(x=>x.onclick=()=>{i=(i-1+slides.length)%slides.length;show(i)});setInterval(()=>{i=(i+1)%slides.length;show(i)},6000);});
});

document.addEventListener('click', function(event) {
  const minus = event.target.closest('[data-qty-minus]');
  const plus = event.target.closest('[data-qty-plus]');

  if (minus || plus) {
    const qtyWrap = event.target.closest('[data-kg-qty]');
    const input = qtyWrap && qtyWrap.querySelector('[data-qty-input]');
    if (!input) return;
    const current = Math.max(1, parseInt(input.value || '1', 10));
    input.value = minus ? Math.max(1, current - 1) : current + 1;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  const whatsappButton = event.target.closest('[data-whatsapp-order]');
  if (!whatsappButton) return;

  const product = whatsappButton.closest('[data-kg-product]');
  if (!product) return;

  const title = product.dataset.productTitle || 'Product';
  const url = product.dataset.productUrl || window.location.href;
  const whatsapp = product.dataset.whatsapp || '923140101061';
  const variantSelect = product.querySelector('[data-kg-variant]');
  const selectedOption = variantSelect && variantSelect.options
    ? variantSelect.options[variantSelect.selectedIndex]
    : null;
  const variant = selectedOption
    ? (selectedOption.dataset.title || selectedOption.text || 'Standard')
    : 'Standard';
  const priceNode = product.querySelector('[data-kg-price]');
  const price = selectedOption?.dataset.price || priceNode?.textContent?.trim() || product.dataset.demoPrice || '';
  const qtyInput = product.querySelector('[data-qty-input]');
  const quantity = Math.max(1, parseInt(qtyInput?.value || '1', 10));

  const message = [
    'Assalam-o-Alaikum, I want to order:',
    '',
    'Product: ' + title,
    'Size / Variant: ' + variant,
    'Quantity: ' + quantity,
    'Price: ' + price,
    'Product link: ' + url,
    '',
    'Please confirm availability and total amount.'
  ].join('\n');

  window.open('https://wa.me/' + whatsapp + '?text=' + encodeURIComponent(message), '_blank', 'noopener');
});

document.addEventListener('change', function(event) {
  const variantSelect = event.target.closest('[data-kg-variant]');
  if (!variantSelect || !variantSelect.options) return;
  const product = variantSelect.closest('[data-kg-product]');
  const priceNode = product && product.querySelector('[data-kg-price]');
  const option = variantSelect.options[variantSelect.selectedIndex];
  if (priceNode && option?.dataset.price) {
    priceNode.textContent = option.dataset.price;
  }
});


document.addEventListener('click', function(event) {
  const cartButton = event.target.closest('[data-cart-whatsapp]');
  if (!cartButton) return;

  const summary = cartButton.closest('[data-kg-cart-summary]');
  const form = document.getElementById('kg-cart-form');
  const dataNode = form && form.querySelector('[data-kg-cart-items]');
  if (!summary || !dataNode) return;

  let items = [];
  try {
    items = JSON.parse(dataNode.textContent);
  } catch (error) {
    console.error('Could not read cart items', error);
  }

  const lines = ['Assalam-o-Alaikum, I want to order these cart items:', ''];

  items.forEach(function(item, index) {
    const variant = item.variant && item.variant !== 'Default Title' ? ' | ' + item.variant : '';
    lines.push((index + 1) + '. ' + item.title + variant);
    lines.push('   Quantity: ' + item.quantity);
    lines.push('   Amount: ' + item.price);
  });

  lines.push('');
  lines.push('Cart Total: ' + (summary.dataset.cartTotal || ''));
  lines.push('Please confirm availability, delivery charges and final total.');

  const number = summary.dataset.whatsapp || '923140101061';
  window.open('https://wa.me/' + number + '?text=' + encodeURIComponent(lines.join('\n')), '_blank', 'noopener');
});
